import type { Logger } from 'log4js';
import type { AwLogLevel } from './logLevel';
import { LOG_LEVEL } from './logLevel';

export type LogMethod = (...args: unknown[]) => void;

// The log-method surface of the injected $logger, provided by both instances.
// The client (console-based) logger implements exactly this.
export interface AwLoggerClient {
  [LOG_LEVEL.TRACE]: LogMethod;
  [LOG_LEVEL.DEBUG]: LogMethod;
  [LOG_LEVEL.INFO]: LogMethod;
  [LOG_LEVEL.WARN]: LogMethod;
  [LOG_LEVEL.ERROR]: LogMethod;
  [LOG_LEVEL.FATAL]: LogMethod;
}

// The server logger is a log4js Logger (wrapped in a Proxy), so it additionally
// carries log4js's own members (addContext, removeContext, level, ...).
export interface AwLoggerServer extends Omit<Logger, AwLogLevel>, AwLoggerClient {}

export const LOG_LEVEL_HIERARCHY = {
  [LOG_LEVEL.TRACE]: 0,
  [LOG_LEVEL.DEBUG]: 1,
  [LOG_LEVEL.INFO]: 2,
  [LOG_LEVEL.WARN]: 3,
  [LOG_LEVEL.ERROR]: 4,
  [LOG_LEVEL.FATAL]: 5,
} as const satisfies Record<AwLogLevel, number>;


const logLevelsArray = objectValuesReadonly(LOG_LEVEL);

export function isAwLogLevel (value: unknown): value is AwLogLevel {
  return (logLevelsArray as unknown[]).includes(value);
}

function objectValuesReadonly<T extends object> (obj: T): ReadonlyArray<T[keyof T]> {
  return Object.values(obj);
}
